(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flamengo-home-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-fg-home-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const select = (tab) => {
        tabs.forEach(t => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
          root.querySelector('#' + CSS.escape(t.getAttribute('aria-controls'))).hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowLeft') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowRight') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamengo-product-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flamengo-product-discovery')) {
  customElements.define('flamengo-product-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const visible = this.tabs.filter(item => !item.hidden);
          const index = visible.indexOf(tab);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : (index + (event.key === 'ArrowLeft' ? 1 : -1) + visible.length) % visible.length;
          this.activate(visible[next].dataset.tab);
          visible[next].focus();
        });
      });
      this.panels.forEach(panel => panel.querySelector('ul').addEventListener('scroll', () => this.update(), {passive:true}));
      this.prev.addEventListener('click', () => this.move(1));
      this.next.addEventListener('click', () => this.move(-1));
      this.initializeCards(this);
      this.activate('related');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load('related');
        this.load('complementary');
        if (this.dataset.collection) this.load('popular');
      }, {rootMargin:'600px'});
      this.observer.observe(this);
    }
    initializeCards(scope) {
      scope.querySelectorAll('[data-discovery-media]').forEach(script => {
        if (script.dataset.ready) return;
        script.dataset.ready = 'true';
        try {
          const data = JSON.parse(script.textContent);
          const map = data.map || {};
          let mediaId = Number(data.native) || 0;
          const override = map.__nativeOverrides?.[data.color];
          if (Array.isArray(map.__missingColors) && map.__missingColors.includes(data.color)) mediaId = 0;
          else if (mediaId && override && Array.isArray(override.from) && override.from.some(id => Number(id) === mediaId)) mediaId = Number(override.to) || 0;
          else if (!mediaId) mediaId = Number(map[data.color]) || 0;
          const source = data.images?.[String(mediaId)];
          const card = script.closest('[data-product]');
          const img = card.querySelector('img');
          if (!source || !img) return;
          img.removeAttribute('srcset');
          img.src = source;
          const color = card.querySelector('.flamengo-discovery__color');
          if (color) color.hidden = false;
          const link = card.querySelector('a');
          if (link.dataset.variantUrl) link.href = link.dataset.variantUrl;
        } catch (error) {}
      });
    }
    activate(intent) {
      this.tabs.forEach(tab => {
        const selected = tab.dataset.tab === intent;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => panel.hidden = panel.dataset.panel !== intent);
      this.track = this.querySelector('[data-panel="' + intent + '"] ul');
      this.update();
    }
    move(direction) {
      this.track.scrollBy({left:direction*this.track.clientWidth*.88,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    update() {
      if (!this.track) return;
      this.prev.disabled = Math.abs(this.track.scrollLeft) < 2;
      this.next.disabled = this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft) < 2;
    }
    async load(intent) {
      const url = new URL(intent === 'popular' ? this.dataset.collection : this.dataset.recommendations, location.origin);
      url.searchParams.set('section_id', intent === 'popular' ? 'flamengo-product-discovery' : this.dataset.section);
      if (intent === 'popular') {
        url.searchParams.set('sort_by', 'best-selling');
        url.searchParams.set('filter.v.availability', '1');
      } else {
        url.searchParams.set('product_id', this.dataset.product);
        url.searchParams.set('intent', intent);
        url.searchParams.set('limit', '10');
      }
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-discovery-results]');
        if (!results) return;
        const seen = new Set([this.dataset.product]);
        const cards = [...results.querySelectorAll('[data-product]')].filter(card => {
          if (seen.has(card.dataset.product)) return false;
          seen.add(card.dataset.product);
          return true;
        }).slice(0,12);
        if (!cards.length || !this.isConnected) return;
        const panel = this.querySelector('[data-panel="' + intent + '"]');
        panel.querySelector('ul').replaceChildren(...cards);
        this.initializeCards(panel);
        this.querySelector('[data-tab="' + intent + '"]').hidden = false;
        this.update();
      } catch (error) {}
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamengo-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'flamengo_recently_viewed_v1';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('he-IL', {
        style: 'currency',
        currency: currency || 'ILS',
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ₪';
    }
  }

  function readItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function createCard(item, currency) {
    var article = document.createElement('article');
    article.className = 'flamengo-recent-card';
    article.setAttribute('role', 'listitem');

    var link = document.createElement('a');
    link.className = 'flamengo-recent-card__link';
    link.href = item.url || '#';

    var media = document.createElement('div');
    media.className = 'flamengo-recent-card__media';

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'flamengo-recent-card__image';
      img.src = item.image;
      img.alt = item.title || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'flamengo-recent-card__info';

    var title = document.createElement('h3');
    title.className = 'flamengo-recent-card__title';
    title.textContent = item.title || '';

    var prices = document.createElement('div');
    prices.className = 'flamengo-recent-card__prices';

    var price = document.createElement('span');
    price.className = 'flamengo-recent-card__price';
    price.textContent = money(item.price, currency);

    var compareValue = Number(item.compare || 0);
    var priceValue = Number(item.price || 0);

    if (compareValue > priceValue) {
      price.classList.add('is-sale');

      var compare = document.createElement('s');
      compare.className = 'flamengo-recent-card__compare';
      compare.textContent = money(compareValue, currency);
      prices.appendChild(price);
      prices.appendChild(compare);
    } else {
      prices.appendChild(price);
    }

    info.appendChild(title);
    info.appendChild(prices);
    link.appendChild(media);
    link.appendChild(info);
    article.appendChild(link);

    return article;
  }

  function initSection(root) {
    if (!root || root.dataset.recentReady === 'true') return;
    root.dataset.recentReady = 'true';

    var currentId = String(root.dataset.productId || '');
    var currentTitle = root.dataset.productTitle || '';
    var currentUrl = root.dataset.productUrl || '';
    var currentImage = root.dataset.productImage || '';
    var currentPrice = Number(root.dataset.productPrice || 0);
    var currentCompare = Number(root.dataset.productCompare || 0);
    var currency = root.dataset.currency || 'ILS';
    var maxItems = parseInt(root.dataset.maxItems || '5', 10);
    var storageLimit = parseInt(root.dataset.storageLimit || '12', 10);

    var grid = root.querySelector('[data-recently-grid]');
    var empty = root.querySelector('[data-recently-empty]');

    var items = readItems();

    var visibleItems = items
      .filter(function (item) {
        return String(item.id) !== currentId;
      })
      .slice(0, maxItems);

    if (visibleItems.length > 0 && grid) {
      visibleItems.forEach(function (item) {
        grid.appendChild(createCard(item, currency));
      });

      root.classList.add('is-visible');
    } else if (empty) {
      empty.hidden = false;
    }

    if (currentId && currentTitle && currentUrl) {
      var currentItem = {
        id: currentId,
        title: currentTitle,
        url: currentUrl,
        image: currentImage,
        price: currentPrice,
        compare: currentCompare,
        viewedAt: Date.now()
      };

      items = items.filter(function (item) {
        return String(item.id) !== currentId;
      });

      items.unshift(currentItem);

      if (items.length > storageLimit) {
        items = items.slice(0, storageLimit);
      }

      saveItems(items);
    }
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-recently-viewed]')) {
      initSection(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-recently-viewed]').forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamengo-shop-the-latest"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.flamengoLatestReady === 'true') return;

    root.dataset.flamengoLatestReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-flamengo-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-flamengo-panel]'));
    var batchSize = parseInt(root.dataset.batchSize || '10', 10);

    function updateMoreButton(panel) {
      if (!panel) return;
      var button = panel.querySelector('[data-flamengo-more]');
      if (!button) return;

      var remaining = panel.querySelectorAll('[data-flamengo-card][hidden]').length;
      button.hidden = remaining === 0;
    }

    function activateTab(button) {
      var panelId = button.getAttribute('data-panel-id');

      tabs.forEach(function (tab) {
        var active = tab === button;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.id !== panelId;
      });

      updateMoreButton(root.querySelector('#' + CSS.escape(panelId)));
    }

    tabs.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(button);
      });
    });

    root.querySelectorAll('[data-flamengo-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('[data-flamengo-panel]');
        if (!panel) return;

        var hiddenCards = Array.prototype.slice.call(
          panel.querySelectorAll('[data-flamengo-card][hidden]')
        );

        hiddenCards.slice(0, batchSize).forEach(function (card) {
          card.hidden = false;
        });

        updateMoreButton(panel);
      });
    });

    panels.forEach(updateMoreButton);
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-flamengo-latest]')) {
      initSection(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-flamengo-latest]').forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamengo-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.sizeGuideReady === 'true') return;
    root.dataset.sizeGuideReady = 'true';

    var tabs = root.querySelectorAll('[data-size-tab]');
    var panels = root.querySelectorAll('[data-size-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-size-tab');

        tabs.forEach(function (otherTab) {
          var active = otherTab === tab;
          otherTab.classList.toggle('is-active', active);
          otherTab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-size-panel') === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-size-guide]')) {
      init(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-size-guide]').forEach(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamengo-video-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('play', event => {
  const video = event.target;
  if (!(video instanceof HTMLVideoElement) || !video.classList.contains('fg-video-reviews__video')) return;
  const section = video.closest('.fg-video-reviews');
  section.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-flamengo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCart(root) {
    if (!root || root.dataset.cartReady === 'true') return;
    root.dataset.cartReady = 'true';

    root.querySelectorAll('[data-cart-minus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrapper = button.closest('.flamengo-cart-item__quantity');
        var input = wrapper && wrapper.querySelector('[data-cart-qty]');
        if (!input) return;

        var value = Math.max(0, parseInt(input.value || '0', 10) - 1);
        input.value = value;
      });
    });

    root.querySelectorAll('[data-cart-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrapper = button.closest('.flamengo-cart-item__quantity');
        var input = wrapper && wrapper.querySelector('[data-cart-qty]');
        if (!input) return;

        var value = Math.max(0, parseInt(input.value || '0', 10) + 1);
        input.value = value;
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('.flamengo-cart')) {
      initCart(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('.flamengo-cart').forEach(initCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function updateCartCount(cart) {
    if (!cart) return;

    var selectors = [
      '[data-cart-count]',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (node.classList && node.classList.contains('cart-count-bubble')) {
          var inner = node.querySelector('span[aria-hidden="true"]');
          if (inner) inner.textContent = cart.item_count;
        } else {
          node.textContent = cart.item_count;
        }
      });
    });
  }

  function showToast(root, text) {
    var toast = root.querySelector('[data-collection-toast]');
    if (!toast) return;

    toast.textContent = text || 'נוסף לעגלה ✓';
    toast.hidden = false;

    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.hidden = true;
    }, 2200);
  }

  async function flamengoAddToCart(form, submitButton) {
      var cartDrawer = document.querySelector('cart-drawer');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

      var formData = new FormData(form);

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        var sections = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });

        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
      }

      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        var data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'לא הצלחנו להוסיף את המוצר לעגלה');
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
        } else {
          /* Fallback for themes where renderContents isn't exposed */
          if (data.sections) {
            Object.keys(data.sections).forEach(function (sectionId) {
              var html = data.sections[sectionId];
              if (!html) return;

              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');

              var current = document.getElementById(sectionId);
              var replacement = doc.getElementById(sectionId);

              if (current && replacement) {
                current.replaceWith(replacement);
              }
            });
          }
        }

        window.setTimeout(function () {
          var freshDrawer = document.querySelector('cart-drawer');
          var cartButton = document.querySelector('#cart-icon-bubble');

          if (freshDrawer && typeof freshDrawer.open === 'function') {
            freshDrawer.open(cartButton);
          } else if (cartButton) {
            cartButton.click();
          }
        }, 50);

        return data;
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    }

  function ajaxAdd(root, form) {
    var submit = form.querySelector('[data-quick-submit]');
    var originalText = submit ? submit.textContent : '';

    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      if (!submit.hasAttribute('data-quick-icon')) submit.textContent = 'מוסיף...';
    }

    return flamengoAddToCart(form, submit)
      .then(function () {
        showToast(root, 'נוסף לעגלה ✓');

        var panel = form.closest('[data-quick-panel]');
        if (panel) {
          panel.hidden = true;
          var trigger = panel.closest('.flamengo-card').querySelector('[data-open-quick]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      })
      .catch(function (error) {
        showToast(root, error.message || 'אירעה שגיאה');
      })
      .finally(function () {
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          if (!submit.hasAttribute('data-quick-icon')) submit.textContent = originalText;
        }
      });
  }

  function initContinuousGrid(root) {
    var grid = root.querySelector('[data-collection-grid]');
    var continuation = root.querySelector('[data-collection-continuation]');
    if (!grid || !continuation) return;
    var nextLink = continuation.querySelector('[data-collection-next]');
    if (!nextLink) return;
    var sentinel = continuation.querySelector('[data-collection-sentinel]');
    var status = continuation.querySelector('[data-collection-load-status]');
    var seenProducts = new Set(Array.from(grid.querySelectorAll('[data-product-id]'), function (card) { return card.dataset.productId; }));
    var fetchedPages = new Set();
    var loading = false;
    var failed = false;
    var controller = null;
    var observer = null;
    var disposed = false;
    var restoring = false;
    var restorationCancelled = false;
    var themeId = window.Shopify && window.Shopify.theme && window.Shopify.theme.id;
    var navigationKey = themeId ? 'flamengo:collection:v1:' + themeId + ':' + window.location.href.split('#')[0] : null;
    var maximumRestoredPages = 8;

    function saveNavigationState() {
      if (!navigationKey || restoring || disposed) return;
      try {
        if (!fetchedPages.size || fetchedPages.size > maximumRestoredPages) {
          sessionStorage.removeItem(navigationKey);
          return;
        }
        sessionStorage.setItem(navigationKey, JSON.stringify({ pages: fetchedPages.size, y: window.scrollY, saved: Date.now() }));
      } catch (error) {}
    }

    function cancelRestoration(event) {
      if (event && event.type === 'keydown' && !['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) return;
      restorationCancelled = true;
    }

    function removeRestorationListeners() {
      window.removeEventListener('wheel', cancelRestoration);
      window.removeEventListener('touchstart', cancelRestoration);
      window.removeEventListener('keydown', cancelRestoration);
    }

    async function restoreNavigationState() {
      var entry = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var state = null;
      if (navigationKey && entry && entry.type === 'back_forward') {
        try { state = JSON.parse(sessionStorage.getItem(navigationKey) || 'null'); } catch (error) {}
      }
      var valid = state && Number.isInteger(state.pages) && state.pages > 0 && state.pages <= maximumRestoredPages && Number.isFinite(state.y) && state.y >= 0 && Number.isFinite(state.saved) && Date.now() - state.saved >= 0 && Date.now() - state.saved < 1800000;
      if (valid) {
        restoring = true;
        window.addEventListener('wheel', cancelRestoration, { passive: true });
        window.addEventListener('touchstart', cancelRestoration, { passive: true });
        window.addEventListener('keydown', cancelRestoration);
        var started = Date.now();
        try {
          while (nextLink && fetchedPages.size < state.pages && !restorationCancelled && !disposed && Date.now() - started < 10000) {
            var previousCount = fetchedPages.size;
            await loadMore(false);
            if (failed || fetchedPages.size === previousCount) break;
          }
          if (!restorationCancelled && !disposed && fetchedPages.size === state.pages && root.isConnected) {
            window.scrollTo({ top: state.y, behavior: 'instant' });
          }
        } finally {
          restoring = false;
          removeRestorationListeners();
        }
      }
      if (observer && nextLink && root.isConnected && !disposed) observer.observe(sentinel);
    }

    function pageUrl(href) {
      var url = new URL(href, window.location.href);
      var current = new URL(window.location.href);
      ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      url.searchParams.set('section_id', root.dataset.sectionId);
      return url;
    }

    async function loadMore(focusNewProducts) {
      if (loading || !nextLink || !root.isConnected || disposed) return;
      var requestUrl = pageUrl(nextLink.href);
      if (requestUrl.origin !== window.location.origin || fetchedPages.has(requestUrl.href)) return;
      loading = true;
      failed = false;
      grid.setAttribute('aria-busy', 'true');
      nextLink.setAttribute('aria-disabled', 'true');
      status.textContent = continuation.dataset.loadingLabel;
      controller = new AbortController();
      var timedOut = false;
      var timeout = window.setTimeout(function () { timedOut = true; controller.abort(); }, restoring ? 6000 : 20000);
      try {
        var response = await fetch(requestUrl.href, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        var html = await response.text();
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var incomingRoot = parsed.getElementById(root.id);
        var incomingGrid = incomingRoot && incomingRoot.querySelector('[data-collection-grid]');
        var incomingContinuation = incomingRoot && incomingRoot.querySelector('[data-collection-continuation]');
        if (!incomingGrid || !incomingContinuation) throw new Error('Collection content missing');
        if (!root.isConnected) return;
        var fragment = document.createDocumentFragment();
        var firstNewCard = null;
        incomingGrid.querySelectorAll('[data-product-id]').forEach(function (card) {
          if (seenProducts.has(card.dataset.productId)) return;
          seenProducts.add(card.dataset.productId);
          if (!firstNewCard) firstNewCard = card;
          card.querySelectorAll('img').forEach(function (image) { image.loading = 'lazy'; });
          fragment.appendChild(card);
        });
        grid.appendChild(fragment);
        if (focusNewProducts && firstNewCard) {
          var firstLink = firstNewCard.querySelector('a');
          if (firstLink) firstLink.focus({ preventScroll: true });
        }
        fetchedPages.add(requestUrl.href);
        var incomingNext = incomingContinuation.querySelector('[data-collection-next]');
        if (incomingNext) {
          nextLink.href = incomingNext.getAttribute('href');
          status.textContent = continuation.dataset.loadedLabel.replace('[count]', grid.querySelectorAll('[data-product-id]').length);
        } else {
          var hadFocus = document.activeElement === nextLink;
          nextLink.hidden = true;
          nextLink = null;
          if (observer) observer.disconnect();
          status.textContent = continuation.dataset.completeLabel;
          if (hadFocus) { status.tabIndex = -1; status.focus({ preventScroll: true }); }
        }
        root.dispatchEvent(new CustomEvent('flamengo:collection:loaded', { bubbles: true }));
      } catch (error) {
        if (error.name !== 'AbortError' || timedOut) {
          failed = true;
          status.textContent = continuation.dataset.errorLabel;
        }
      } finally {
        window.clearTimeout(timeout);
        loading = false;
        grid.setAttribute('aria-busy', 'false');
        if (nextLink) nextLink.removeAttribute('aria-disabled');
        if (observer && nextLink && !failed && !restoring && !disposed && root.isConnected) {
          requestAnimationFrame(function () {
            if (!restoring && !disposed && sentinel.getBoundingClientRect().top < window.innerHeight + 600) loadMore();
          });
        }
      }
    }

    continuation.addEventListener('click', function (event) {
      if (!event.target.closest('[data-collection-next]') || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      loadMore(event.detail === 0);
    });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; }) && !failed && !restoring && !disposed) loadMore();
      }, { rootMargin: '600px 0px' });
    }
    function cleanupContinuousGrid(event) {
      if (!event.target.contains(root)) return;
      disposed = true;
      restorationCancelled = true;
      removeRestorationListeners();
      if (observer) observer.disconnect();
      if (controller) controller.abort();
      window.removeEventListener('pagehide', saveNavigationState);
      document.removeEventListener('shopify:section:unload', cleanupContinuousGrid);
    }
    window.addEventListener('pagehide', saveNavigationState);
    document.addEventListener('shopify:section:unload', cleanupContinuousGrid);
    restoreNavigationState();
  }

  function initCollection(root) {
    if (!root || root.dataset.collectionReady === 'true') return;
    root.dataset.collectionReady = 'true';
    var drawer = root.querySelector('[data-filter-drawer]');
    var openButton = root.querySelector('[data-open-filters]');
    var sortSelect = root.querySelector('[data-sort-select]');
    var previousOverflow = '';
    var previousFocus = null;
    var desktopMedia = window.matchMedia('(min-width: 990px)');

    function preservePreview(url) {
      var current = new URL(window.location.href);
      ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      return url;
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var next = new URL(link.href, window.location.href);
      if (next.origin !== window.location.origin || next.pathname !== window.location.pathname) return;
      link.href = preservePreview(next).href;
    });

    root.querySelectorAll('.flamengo-collection-pro__price-form').forEach(function (form) {
      var minimum = form.querySelector('input[name$=".gte"]');
      var maximum = form.querySelector('input[name$=".lte"]');
      if (!minimum || !maximum) return;
      function clearPriceError() { maximum.setCustomValidity(''); }
      minimum.addEventListener('input', clearPriceError);
      maximum.addEventListener('input', clearPriceError);
      form.addEventListener('submit', function (event) {
        clearPriceError();
        if (minimum.value !== '' && maximum.value !== '' && minimum.valueAsNumber > maximum.valueAsNumber) {
          event.preventDefault();
          maximum.setCustomValidity('המחיר המרבי צריך להיות גדול או שווה למחיר ההתחלתי');
          maximum.reportValidity();
        }
      });
    });

    root.querySelectorAll('.flamengo-collection-pro__sort-form, .flamengo-collection-pro__price-form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var current = new URL(window.location.href);
        ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
          if (!current.searchParams.has(key)) return;
          var input = form.querySelector('input[name="' + key + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            form.appendChild(input);
          }
          input.value = current.searchParams.get(key);
        });
      });
    });

    function openDrawer() {
      if (!drawer || !drawer.hidden) return;
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      drawer.hidden = false;
      root.classList.add('has-filter-drawer');
      document.documentElement.style.overflow = 'hidden';
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
      var closeButton = drawer.querySelector('.flamengo-collection-pro__drawer-close');
      (closeButton || drawer).focus({ preventScroll: true });
    }

    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      root.classList.remove('has-filter-drawer');
      document.documentElement.style.overflow = previousOverflow;
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    }

    function handleDesktopChange(event) {
      if (event.matches) closeDrawer();
    }

    if (openButton) openButton.addEventListener('click', openDrawer);
    desktopMedia.addEventListener('change', handleDesktopChange);

    root.querySelectorAll('[data-close-filters]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    if (sortSelect && sortSelect.form) {
      sortSelect.addEventListener('change', function () {
        sortSelect.form.requestSubmit();
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-open-quick]');
      if (button) {
        var card = button.closest('.flamengo-card');
        var panel = card && card.querySelector('[data-quick-panel]');
        if (!panel) return;
        root.querySelectorAll('[data-quick-panel]').forEach(function (other) {
          if (other !== panel) other.hidden = true;
        });
        root.querySelectorAll('[data-open-quick]').forEach(function (other) {
          if (other !== button) other.setAttribute('aria-expanded', 'false');
        });
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
        return;
      }
      var close = event.target.closest('[data-close-quick]');
      if (close) {
        var currentPanel = close.closest('[data-quick-panel]');
        if (currentPanel) currentPanel.hidden = true;
        var trigger = close.closest('.flamengo-card').querySelector('[data-open-quick]');
        if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
      }
    });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-quick-form]');
      if (!form) return;
      event.preventDefault();
      var select = form.querySelector('select[name="id"]');
      if (select && !select.value) {
        showToast(root, 'בחרו מידה / צבע');
        return;
      }
      var submit = form.querySelector('[data-quick-submit]');
      if (submit && submit.disabled) return;
      ajaxAdd(root, form);
    });

    initContinuousGrid(root);

    function handleCollectionKeydown(event) {
      if (drawer && !drawer.hidden && event.key === 'Tab') {
        var focusable = Array.from(drawer.querySelectorAll('.flamengo-collection-pro__drawer-panel a[href]:not([aria-disabled="true"]), .flamengo-collection-pro__drawer-panel button:not([disabled]), .flamengo-collection-pro__drawer-panel input:not([type="hidden"]):not([disabled]), .flamengo-collection-pro__drawer-panel select:not([disabled])')).filter(function (element) {
          return element.offsetParent !== null && element.tabIndex >= 0;
        });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!first) {
          event.preventDefault();
          drawer.focus();
        } else if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
      if (event.key === 'Escape') {
        closeDrawer();
        root.querySelectorAll('[data-quick-panel]').forEach(function (panel) {
          panel.hidden = true;
        });
        root.querySelectorAll('[data-open-quick]').forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
      }
    }
    function cleanupCollection(event) {
      if (!event.target.contains(root)) return;
      if (drawer && !drawer.hidden) closeDrawer();
      desktopMedia.removeEventListener('change', handleDesktopChange);
      document.removeEventListener('keydown', handleCollectionKeydown);
      document.removeEventListener('shopify:section:unload', cleanupCollection);
    }
    document.addEventListener('keydown', handleCollectionKeydown);
    document.addEventListener('shopify:section:unload', cleanupCollection);
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-flamengo-collection]')) {
      initCollection(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-flamengo-collection]').forEach(initCollection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('he-IL', {
        style: 'currency',
        currency: currency || 'ILS',
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ₪';
    }
  }

  function initProduct(root) {
    if (!root || root.dataset.flamengoProductReady === 'true') return;
    root.dataset.flamengoProductReady = 'true';

    var variantsNode = root.querySelector('[data-product-variants]');
    if (!variantsNode) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (e) {
      return;
    }

    function readJson(selector, fallback) {
      try {
        var node = root.querySelector(selector);
        return node ? JSON.parse(node.textContent || '{}') : fallback;
      } catch (error) {
        return fallback;
      }
    }

    var strings = readJson('[data-pdp-strings]', {});
    var variantMedia = readJson('[data-variant-media]', {});
    var colorMedia = readJson('[data-color-media-map]', {});
    var fieldsets = Array.from(root.querySelectorAll('.flamengo-product__option'));
    root.querySelectorAll('[data-size-option]').forEach(function (fieldset) {
      var container = fieldset.querySelector('.flamengo-product__option-values');
      if (!container) return;
      var letterSizes = { XXXS: 0, XXS: 1, '2XS': 1, XS: 2, S: 3, M: 4, L: 5, XL: 6, XXL: 7, '2XL': 7, XXXL: 8, '3XL': 8, XXXXL: 9, '4XL': 9, '5XL': 10, '6XL': 11 };
      function sizeRank(value) {
        var normalized = String(value).trim().toUpperCase().replace(/\s+/g, '').replace(/[–—]/g, '-');
        if (Object.prototype.hasOwnProperty.call(letterSizes, normalized)) return [1, letterSizes[normalized]];
        var numeric = normalized.match(/^(\d+(?:\.\d+)?)(?:[-/](\d+(?:\.\d+)?))?$/);
        if (numeric) return [0, Number(numeric[1]), Number(numeric[2] || numeric[1])];
        return [2, 0];
      }
      Array.from(container.querySelectorAll('input[type="radio"]')).map(function (input, index) {
        return { input: input, label: input.nextElementSibling, rank: sizeRank(input.value), index: index };
      }).sort(function (a, b) {
        return a.rank[0] - b.rank[0] || a.rank[1] - b.rank[1] || (a.rank[2] || 0) - (b.rank[2] || 0) || a.index - b.index;
      }).forEach(function (entry) {
        container.appendChild(entry.input);
        if (entry.label && entry.label.tagName === 'LABEL') container.appendChild(entry.label);
      });
    });
    var colorFieldset = root.querySelector('[data-color-option]');
    var colorIndex = colorFieldset ? Number(colorFieldset.dataset.optionPosition) - 1 : -1;
    var selectionNote = root.querySelector('[data-selection-note]');
    var formMessage = root.querySelector('[data-form-message]');
    var inventoryNode = root.querySelector('[data-product-inventory]');
    var buyNow = root.querySelector('[data-buy-now]');
    var cartPending = false;
    var blockedNativeColor = false;
    var form = root.querySelector('.flamengo-product__form');
    var variantInput = root.querySelector('[data-variant-id]');
    var priceNode = root.querySelector('[data-product-price]');
    var compareNode = root.querySelector('[data-product-compare]');
    var discountNode = root.querySelector('[data-product-discount]');
    var savingNode = root.querySelector('[data-product-saving]');
    var skuNode = root.querySelector('[data-product-sku]');
    var addButton = root.querySelector('[data-add-button]');
    var addButtonText = root.querySelector('[data-add-button-text]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var stickyBar = root.querySelector('[data-mobile-sticky]');
    var stickySelection = root.querySelector('[data-sticky-selection]');
    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        stickyBar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
      });
      stickyObserver.observe(addButton);
      root.addEventListener('shopify:section:unload', function () { stickyObserver.disconnect(); }, { once: true });
    }
    var currency = root.dataset.currency || 'ILS';

    var gallery = root.querySelector('[data-product-gallery]');
    var galleryItems = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-item]')) : [];
    var galleryThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    var galleryPrev = root.querySelector('[data-gallery-prev]');
    var galleryNext = root.querySelector('[data-gallery-next]');
    var galleryNote = root.querySelector('[data-gallery-note]');
    var galleryIndex = 0;

    function setGalleryIndex(index, options) {
      if (!galleryItems.length) return;

      galleryIndex = Math.max(0, Math.min(index, galleryItems.length - 1));
      var isMobile = window.matchMedia('(max-width: 989px)').matches;

      galleryItems.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === galleryIndex);
      });

      galleryThumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === galleryIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (isMobile && galleryItems[galleryIndex] && !(options && (options.fromScroll || options.skipScroll))) {
        var galleryRect = gallery.getBoundingClientRect();
        var itemRect = galleryItems[galleryIndex].getBoundingClientRect();
        var rtl = window.getComputedStyle(gallery).direction === 'rtl';
        var distance = rtl ? itemRect.right - galleryRect.right : itemRect.left - galleryRect.left;
        gallery.scrollBy({
          left: distance,
          behavior: (options && options.instant) || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      if (galleryPrev) galleryPrev.disabled = galleryIndex <= 0;
      if (galleryNext) galleryNext.disabled = galleryIndex >= galleryItems.length - 1;
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setGalleryIndex(parseInt(thumb.dataset.galleryIndex || '0', 10), { instant: true });
      });
    });

    if (galleryPrev) {
      galleryPrev.addEventListener('click', function () {
        setGalleryIndex(galleryIndex - 1);
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', function () {
        setGalleryIndex(galleryIndex + 1);
      });
    }

    if (gallery && galleryItems.length > 1 && 'IntersectionObserver' in window) {
      var galleryObserver = new IntersectionObserver(function (entries) {
        if (!window.matchMedia('(max-width: 989px)').matches) return;

        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var index = parseInt(entry.target.dataset.galleryIndex || '0', 10);
            if (index !== galleryIndex) setGalleryIndex(index, { fromScroll: true });
          }
        });
      }, {
        root: gallery,
        threshold: [0.6]
      });

      galleryItems.forEach(function (item) {
        galleryObserver.observe(item);
      });
    }

    setGalleryIndex(galleryItems.findIndex(function (item) { return item.classList.contains('is-active'); }), { instant: true, skipScroll: true });

    function getSelectedOptions() {
      var selected = [];
      fieldsets.forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        selected[Number(fieldset.dataset.optionPosition) - 1] = checked ? checked.value : '';
      });
      return selected;
    }

    function findVariant() {
      if (variants.length === 1) return variants[0];
      var selected = getSelectedOptions();
      return variants.find(function (variant) {
        return variant.options && variant.options.length === selected.length && variant.options.every(function (value, index) {
          return String(value) === String(selected[index]);
        });
      });
    }

    function updateOptionAvailability() {
      var selected = getSelectedOptions();
      fieldsets.forEach(function (fieldset) {
        var index = Number(fieldset.dataset.optionPosition) - 1;
        var isColor = fieldset.hasAttribute('data-color-option');
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var available = variants.some(function (variant) {
            if (!variant.available || String(variant.options[index]) !== input.value) return false;
            return isColor || variant.options.every(function (value, otherIndex) {
              return otherIndex === index || !selected[otherIndex] || String(value) === String(selected[otherIndex]);
            });
          });
          input.disabled = !isColor && !available;
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function resolveColorMedia(nativeMediaId, colorValue, mapping) {
      if (Array.isArray(mapping.__missingColors) && mapping.__missingColors.indexOf(colorValue) >= 0) {
        return { mediaId: 0, overridden: true, blocked: true };
      }
      var overrides = mapping.__nativeOverrides;
      var override = overrides && Object.prototype.hasOwnProperty.call(overrides, colorValue) ? overrides[colorValue] : null;
      if (nativeMediaId && override && Array.isArray(override.from) && override.from.some(function (id) {
        return String(id) === String(nativeMediaId);
      }) && Number.isSafeInteger(override.to) && override.to >= 0) {
        return { mediaId: override.to, overridden: true, blocked: override.to === 0 };
      }
      var fallback = colorValue && Object.prototype.hasOwnProperty.call(mapping, colorValue) ? mapping[colorValue] : 0;
      return { mediaId: nativeMediaId || fallback || 0, overridden: false, blocked: false };
    }

    function syncVariantGallery(variant) {
      var selected = getSelectedOptions();
      var colorValue = colorIndex >= 0 ? selected[colorIndex] : '';
      var mediaId = variant && (variantMedia[String(variant.id)] || (variant.featured_media && variant.featured_media.id));
      if (!mediaId && colorValue) {
        var sibling = variants.find(function (candidate) {
          return String(candidate.options[colorIndex]) === String(colorValue) && (variantMedia[String(candidate.id)] || (candidate.featured_media && candidate.featured_media.id));
        });
        if (sibling) mediaId = variantMedia[String(sibling.id)] || sibling.featured_media.id;
      }
      var resolved = resolveColorMedia(mediaId, colorValue, colorMedia);
      mediaId = resolved.mediaId;
      blockedNativeColor = resolved.blocked;
      if (blockedNativeColor && selectionNote) selectionNote.textContent = strings.image_unavailable;
      var index = mediaId ? galleryItems.findIndex(function (item) {
        return String(item.dataset.mediaId) === String(mediaId);
      }) : -1;
      var missingColorImage = Boolean(colorValue && index < 0);
      if (galleryNote) {
        galleryNote.hidden = !missingColorImage;
        galleryNote.textContent = missingColorImage ? strings.image_unavailable : '';
      }
      if (missingColorImage && selectionNote) selectionNote.textContent = strings.image_unavailable;
      if (index >= 0) {
        setGalleryIndex(index, { instant: true });
        if (root.dataset.userVariantChange === 'true' && !window.matchMedia('(max-width: 989px)').matches) {
          galleryItems[index].scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }
      }
      return index >= 0;
    }

    function updateVariant(variant) {
      var available = Boolean(variant && variant.available);
      if (variantInput) variantInput.value = variant ? variant.id : '';
      if (addButton) addButton.disabled = cartPending || !available;
      if (buyNow) buyNow.disabled = cartPending || !available;
      if (stickyAdd) stickyAdd.disabled = cartPending || !available;
      if (!cartPending) {
        var label = variant ? (available ? strings.add_to_cart : strings.sold_out) : strings.unavailable;
        if (addButtonText) addButtonText.textContent = label;
        if (stickyAdd) stickyAdd.textContent = label;
        if (buyNow) buyNow.textContent = strings.buy_now;
      }
      updateOptionAvailability();
      if (inventoryNode) {
        inventoryNode.replaceChildren();
        var dot = document.createElement('span');
        dot.className = 'flamengo-product__inventory-dot' + (available ? '' : ' is-out');
        var text = document.createElement('span');
        text.textContent = available ? strings.in_stock : (variant ? strings.sold_out : strings.unavailable);
        inventoryNode.append(dot, text);
      }
      var imageShown = syncVariantGallery(variant);
      if (!variant) {
        if (priceNode) priceNode.textContent = strings.unavailable;
        if (stickyPrice) stickyPrice.textContent = strings.unavailable;
        [compareNode, discountNode, savingNode].forEach(function (node) {
          if (node) node.classList.add('is-hidden');
        });
        if (skuNode) skuNode.textContent = '';
        return imageShown;
      }
      var onSale = Number(variant.compare_at_price) > Number(variant.price);
      var saving = onSale ? Number(variant.compare_at_price) - Number(variant.price) : 0;
      var percent = onSale ? Math.round((saving * 100) / Number(variant.compare_at_price)) : 0;
      if (priceNode) {
        priceNode.textContent = formatMoney(variant.price, currency);
        priceNode.classList.toggle('flamengo-product__price--sale', onSale);
      }
      if (compareNode) {
        compareNode.textContent = onSale ? formatMoney(variant.compare_at_price, currency) : '';
        compareNode.classList.toggle('is-hidden', !onSale);
      }
      if (discountNode) {
        discountNode.textContent = onSale ? '-' + percent + '%' : '';
        discountNode.classList.toggle('is-hidden', !onSale);
      }
      if (savingNode) {
        savingNode.textContent = onSale ? 'חסכת ' + formatMoney(saving, currency) : '';
        savingNode.classList.toggle('is-hidden', !onSale);
      }
      if (skuNode) skuNode.textContent = variant.sku || '';
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, currency);
      if (stickySelection) stickySelection.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
      return imageShown;
    }

    root.querySelectorAll('.flamengo-product__option-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var changedColor = Number(input.dataset.optionIndex) === colorIndex;
        var variant = findVariant();
        var notices = [];
        if (changedColor && (!variant || !variant.available)) {
          notices.push(strings.selection_unavailable);
        }
        root.dataset.userVariantChange = 'true';
        var imageShown = updateVariant(variant);
        delete root.dataset.userVariantChange;
        if ((changedColor || blockedNativeColor) && !imageShown) notices.push(strings.image_unavailable);
        if (selectionNote) selectionNote.textContent = notices.join(' ');
        if (formMessage) formMessage.textContent = '';
      });
    });

    var qtyInput = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');

    if (minus && qtyInput) {
      minus.addEventListener('click', function () {
        var value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        qtyInput.value = value;
      });
    }

    if (plus && qtyInput) {
      plus.addEventListener('click', function () {
        var value = Math.max(1, parseInt(qtyInput.value || '1', 10) + 1);
        qtyInput.value = value;
      });
    }

    updateVariant(findVariant());

    function showMessage(node, message, isError) {
      if (!node) return;
      node.textContent = message || '';
      node.classList.toggle('is-error', Boolean(isError));
    }

    var upsell = root.querySelector('[data-pdp-upsell]');
    var upsellForm = upsell && upsell.querySelector('form');
    var upsellSelect = upsell && upsell.querySelector('[data-upsell-variant]');
    var upsellAdd = upsell && upsell.querySelector('[data-upsell-add]');
    var upsellMessage = upsell && upsell.querySelector('[data-upsell-message]');
    var upsellLabel = upsellAdd ? upsellAdd.textContent : '';
    var upsellImage = upsell && upsell.querySelector('.flamengo-pdp-upsell__image');
    var upsellImageNote = upsell && upsell.querySelector('[data-upsell-image-note]');
    var upsellDefaultSrc = upsellImage ? upsellImage.getAttribute('src') : '';
    var upsellDefaultSrcset = upsellImage ? upsellImage.getAttribute('srcset') : '';
    var upsellMedia = readJson('[data-upsell-media]', { variants: {}, images: {}, colorIndex: -1 });
    var upsellColorMedia = readJson('[data-upsell-color-media]', {});

    function syncUpsellImage(selected) {
      if (!selected) return;
      var variant = upsellMedia.variants[String(selected.value)] || {};
      var nativeMediaId = variant.media || 0;
      var imageUrl = selected.dataset.image || upsellMedia.images[String(nativeMediaId)];
      if (!imageUrl && variant.color) {
        var sibling = Object.values(upsellMedia.variants).find(function (candidate) {
          return candidate.color === variant.color && upsellMedia.images[String(candidate.media)];
        });
        if (sibling) {
          nativeMediaId = sibling.media;
          imageUrl = upsellMedia.images[String(nativeMediaId)];
        }
      }
      var resolved = resolveColorMedia(nativeMediaId, variant.color || '', upsellColorMedia);
      imageUrl = resolved.overridden ? upsellMedia.images[String(resolved.mediaId)] : imageUrl || upsellMedia.images[String(resolved.mediaId)];
      if (upsellImage) {
        upsellImage.src = imageUrl || upsellDefaultSrc;
        if (!imageUrl && upsellDefaultSrcset) {
          upsellImage.setAttribute('srcset', upsellDefaultSrcset);
        } else {
          upsellImage.removeAttribute('srcset');
        }
      }
      showMessage(upsellImageNote, variant.color && !imageUrl ? strings.image_unavailable : '', false);
    }

    function syncCartButtons() {
      updateVariant(findVariant());
      if (upsellAdd) upsellAdd.disabled = cartPending || !upsellSelect.value;
    }

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var variant = findVariant();
        if (cartPending || !variant || !variant.available || !form.reportValidity()) return;
        var checkout = Boolean(event.submitter && event.submitter.hasAttribute('data-buy-now'));
        cartPending = true;
        syncCartButtons();
        showMessage(formMessage, '', false);
        if (checkout && buyNow) buyNow.textContent = strings.buying;
        if (!checkout && addButtonText) addButtonText.textContent = strings.adding;
        if (!checkout && stickyAdd) stickyAdd.textContent = strings.adding;
        var checkoutStarted = false;
        try {
          await flamengoAddToCart(form, { checkout: checkout, errorMessage: strings.add_error });
          checkoutStarted = checkout;
          if (!checkout) showMessage(formMessage, strings.added, false);
        } catch (error) {
          showMessage(formMessage, error.message || strings.add_error, true);
        } finally {
          if (!checkoutStarted) {
            cartPending = false;
            syncCartButtons();
          }
        }
      });
    }

    if (upsellSelect) {
      upsellSelect.addEventListener('change', function () {
        var selected = upsellSelect.selectedOptions[0];
        var upsellPrice = upsell.querySelector('[data-upsell-price]');
        if (upsellPrice && selected) upsellPrice.textContent = formatMoney(selected.dataset.price, currency);
        syncUpsellImage(selected);
        showMessage(upsellMessage, '', false);
        if (upsellAdd) upsellAdd.disabled = cartPending || !upsellSelect.value;
      });
    }
    if (upsellForm) {
      upsellForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (cartPending || !upsellSelect.value || !upsellForm.reportValidity()) return;
        cartPending = true;
        syncCartButtons();
        upsellAdd.textContent = strings.adding;
        showMessage(upsellMessage, '', false);
        try {
          await flamengoAddToCart(upsellForm, { errorMessage: strings.add_error });
          showMessage(upsellMessage, strings.added, false);
        } catch (error) {
          showMessage(upsellMessage, error.message || strings.add_error, true);
        } finally {
          cartPending = false;
          upsellAdd.textContent = upsellLabel;
          syncCartButtons();
        }
      });
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        cartPending = false;
        syncCartButtons();
      }
    });
  }

  async function flamengoAddToCart(form, options) {
    var cartDrawer = document.querySelector('cart-drawer');
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var formData = new FormData(form);
    if (!options.checkout && cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      var sections = cartDrawer.getSectionsToRender().map(function (section) { return section.id; });
      if (sections.length) {
        formData.set('sections', sections.join(','));
        formData.set('sections_url', window.location.pathname);
      }
      if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(document.activeElement);
    }
    var response = await fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    var data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || options.errorMessage);
    if (options.checkout) {
      window.location.assign(routeRoot + 'checkout');
      return data;
    }
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
      try {
        cartDrawer.renderContents(data);
      } catch (error) {
        window.location.assign(routeRoot + 'cart');
      }
    } else {
      window.location.assign(routeRoot + 'cart');
    }
    return data;
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-flamengo-product]')) {
      initProduct(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-flamengo-product]').forEach(initProduct);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  function showToast(root, text) {
    var toast = root.querySelector('[data-search-toast]');
    if (!toast) return;

    toast.textContent = text || 'נוסף לעגלה ✓';
    toast.hidden = false;

    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.hidden = true;
    }, 1800);
  }

  async function addToCart(root, form, button) {
    var cartDrawer = document.querySelector('cart-drawer');
    var shopifyRoot =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    var formData = new FormData(form);

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      var sections = cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      });

      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname + window.location.search);
      }
    }

    var originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'מוסיף...';
    }

    try {
      var response = await fetch(shopifyRoot + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      var data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'לא ניתן להוסיף את המוצר');
      }

      showToast(root, 'נוסף לעגלה ✓');

      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function' &&
        data.sections
      ) {
        cartDrawer.renderContents(data);
      }

      window.setTimeout(function () {
        var drawer = document.querySelector('cart-drawer');
        var cartButton = document.querySelector('#cart-icon-bubble');

        if (drawer && typeof drawer.open === 'function') {
          drawer.open(cartButton);
        } else if (cartButton) {
          cartButton.click();
        }
      }, 70);

      return data;

    } catch (error) {
      showToast(root, error.message || 'אירעה שגיאה');
      throw error;
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  }

  function init(root) {
    if (!root || root.dataset.searchReady === 'true') return;
    root.dataset.searchReady = 'true';

    var jeansQuery = (root.dataset.jeansQuery || '').trim();
    var currentSearchUrl = new URL(window.location.href);
    var currentQuery = currentSearchUrl.searchParams.get('q') || '';
    function normalizeJeansQuery(query) {
      if (!jeansQuery || /[:()"\\]|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/.test(query)) return query;
      return query.replace(/(^|\s)ג[׳'’]?ינס(?:ים)?(?=$|\s)/g, function (_, space) {
        return space + jeansQuery;
      });
    }
    var normalizedQuery = normalizeJeansQuery(currentQuery.trim());
    if (normalizedQuery !== currentQuery && !(window.Shopify && Shopify.designMode)) {
      currentSearchUrl.searchParams.set('q', normalizedQuery);
      currentSearchUrl.searchParams.delete('page');
      window.location.replace(currentSearchUrl.href);
      return;
    }
    if (jeansQuery && currentQuery.indexOf(jeansQuery) !== -1) {
      document.title = document.title.split(jeansQuery).join('ג׳ינס');
      document.querySelectorAll('input[type="search"][name="q"]').forEach(function (input) {
        input.value = input.value.split(jeansQuery).join('ג׳ינס');
      });
    }
    var searchForm = root.querySelector('.flamengo-search__form');
    if (searchForm) searchForm.addEventListener('submit', function (event) {
      var input = searchForm.querySelector('[name="q"]');
      var query = normalizeJeansQuery(input.value.trim());
      if (query === input.value.trim()) return;
      event.preventDefault();
      var destination = new URL(searchForm.action, window.location.href);
      var params = new URLSearchParams(new FormData(searchForm));
      params.set('q', query);
      destination.search = params.toString();
      window.location.assign(destination.href);
    });
    var filterQuery = root.querySelector('.flamengo-refinements__form [name="q"]');
    if (filterQuery) filterQuery.value = currentQuery;
    var clearFilters = root.querySelector('[data-clear-search-filters]');
    if (clearFilters) {
      var clearUrl = new URL(clearFilters.href, window.location.href);
      clearUrl.searchParams.set('q', currentQuery);
      clearFilters.href = clearUrl.href;
    }

    root.querySelectorAll('[data-open-quick]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('.flamengo-search-card');
        if (!card) return;

        var panel = card.querySelector('[data-quick-panel]');
        if (!panel) return;

        root.querySelectorAll('[data-quick-panel]').forEach(function (otherPanel) {
          if (otherPanel !== panel) otherPanel.hidden = true;
        });

        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      });
    });

    root.querySelectorAll('[data-close-quick]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('[data-quick-panel]');
        if (panel) panel.hidden = true;
      });
    });

    root.querySelectorAll('[data-quick-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var select = form.querySelector('select[name="id"]');
        if (select && !select.value) {
          showToast(root, 'בחרו מידה / צבע');
          return;
        }

        var button = form.querySelector('[data-quick-submit]');

        addToCart(root, form, button)
          .then(function () {
            var panel = form.closest('[data-quick-panel]');
            if (panel) panel.hidden = true;
          })
          .catch(function () {});
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        root.querySelectorAll('[data-quick-panel]').forEach(function (panel) {
          panel.hidden = true;
        });
      }
    });
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-flamengo-search]')) {
      init(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-flamengo-search]').forEach(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
if (!customElements.get('flamengo-category-rail')) {
  customElements.define('flamengo-category-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.flamengo-category-items');
      this.back = this.querySelector('[data-back]');
      this.forward = this.querySelector('[data-forward]');
      this.next = new URL(this.dataset.url, location.origin);
      this.next.searchParams.set('section_id', 'related-products');
      this.next.searchParams.set('filter.v.availability', '1');
      if (new URL(location.href).searchParams.has('preview_theme_id')) this.next.searchParams.set('preview_theme_id', this.dataset.preview);
      this.seen = new Set([this.dataset.exclude]);
      this.back.onclick = () => this.move(1);
      this.forward.onclick = () => this.move(-1);
      this.track.addEventListener('scroll', () => {
        this.update();
        if (this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft) < this.track.clientWidth * 2) this.load();
      }, {passive:true});
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault(); this.move(e.key === 'ArrowLeft' ? -1 : 1);
      });
      this.load();
    }
    move(direction) {
      this.track.scrollBy({left:direction * this.track.clientWidth * .9, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto':'smooth'});
      if (direction < 0) this.load();
    }
    update() {
      const remaining = this.track.scrollWidth-this.track.clientWidth-Math.abs(this.track.scrollLeft);
      this.back.disabled = Math.abs(this.track.scrollLeft)<2;
      this.forward.disabled = remaining<2 && !this.next;
    }
    async load() {
      if (this.loading || !this.next || !this.isConnected) return;
      this.loading = true;
      let loaded = false;
      this.track.setAttribute('aria-busy','true');
      try {
        const response = await fetch(this.next.toString());
        if (!response.ok) throw new Error('Unable to load collection');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const list = doc.querySelector('.flamengo-category-items');
        if (!list) throw new Error('Missing collection');
        list.querySelectorAll('.flamengo-category-item').forEach(item => {
          if (!this.seen.has(item.dataset.product)) {
            this.seen.add(item.dataset.product);
            this.track.append(item);
          }
        });
        loaded = true;
        const next = list.querySelector('[data-next]')?.dataset.next;
        if (next) {
          const page = new URL(next,location.origin);
          this.next.searchParams.set('page',page.searchParams.get('page'));
        } else this.next = null;
      } catch (error) {
        this.forward.disabled = false;
      } finally {
        this.loading = false;
        this.track.removeAttribute('aria-busy');
        this.update();
      }
      if (loaded && this.next && this.track.scrollWidth <= this.track.clientWidth) this.load();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
